var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col float-right" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-appr-btn", {
                ref: "appr-btn",
                attrs: {
                  name: "appr-btn",
                  editable: _vm.editable,
                  approvalInfo: _vm.approvalInfo,
                },
                on: {
                  beforeApprAction: _vm.saveDataAppr,
                  callbackApprAction: _vm.approvalCallback,
                  requestAfterAction: _vm.getDetail,
                },
              }),
              _c("c-qr-btn", {
                attrs: {
                  mobileUrl:
                    "/sop/edu/result/educationResult?eduEducationId=" +
                    _vm.param.eduEducationId,
                },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable && _vm.isComplete,
                    expression: "editable && isComplete",
                  },
                ],
                attrs: { label: "LBL0002901", icon: "print" },
                on: { btnClicked: _vm.btnResultReport },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable && _vm.isComplete,
                    expression: "editable && isComplete",
                  },
                ],
                attrs: { label: "LBL0002902", icon: "print" },
                on: { btnClicked: _vm.btnResultUsers },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "vertical",
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    param: _vm.param,
                    planUpdateBtnData: _vm.param.planUpdateBtnData,
                    educationInfo: _vm.educationInfo,
                  },
                  on: {
                    "update:educationInfo": function ($event) {
                      _vm.educationInfo = $event
                    },
                    "update:education-info": function ($event) {
                      _vm.educationInfo = $event
                    },
                    setData: _vm.setData,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }